<template>
	<div id="search">
		<mt-header fixed>
			<mt-button icon="back" slot="left" @click.native="$router.back()"></mt-button>
			<mt-button slot="right" @click="select()">{{ $t('筛选') }}</mt-button>
		</mt-header>
		<form action="" v-on:submit.prevent="">
			<mt-search v-model="searchValue" :cancel-text="cancel" :placeholder="$t('请输入搜索内容')" @keyup.enter.native="search"
				class="font-size-8" style="width:100%;height:auto;">
				<div calss="searchList">
					<ul class="content_detail search_content">
						<li v-for="(val, key) in searchList" :key="key">
							<img v-bind:src="val.img_url" alt="" class="oImg">
							<span class="currency_name">
								<span class="receive wx_fontSize3">{{ val.coin_symbol }}</span>
								<span class="form wx_fontSize2">{{ val.coin_name }}</span>
							</span>
							<div class="amount_of wx_rt wx_fontSize2 color-gray" v-if="val.status == 1"
								@click="deletCion(val.coin_symbol)">{{ $t('移除') }}</div>
							<div class="amount_of wx_rt wx_fontSize2" v-else @click="addCion(val.coin_symbol)">{{ $t('添加') }}</div>
						</li>
					</ul>
				</div>
			</mt-search>
		</form>
		<div ref="main_list" class="main_list">
			<ul class="content_detail main_show">
				<li v-for="(item, index) in CoinsList" style="position: relative;" :key="index">
					<div class="selectCoin" @click="openLlist(index)">
						<img v-bind:src="close" alt="" :style="{ display: item.token_list.data.length == 0 ? 'none' : 'block' }">
					</div>
					<img v-bind:src="item.img_url" alt="" class="oImg">
					<span class="currency_name">
						<span class="receive wx_fontSize3">{{ item.coin_symbol }}</span>
						<span class="form wx_fontSize2">{{ item.coin_name }}</span>
					</span>
					<div class="amount_of wx_rt wx_fontSize2 color-gray" v-if="item.status == 1"
						@click="deletCion(item.coin_symbol)">{{ $t('移除') }}</div>
					<div class="amount_of wx_rt wx_fontSize2" v-else @click="addCion(item.coin_symbol)">{{ $t('添加') }}</div>
					<ul class="content_detail childList">
						<li v-for="(val, key) in item.token_list.data" :key="key">
							<img v-bind:src="val.img_url" alt="" class="oImg">
							<span class="currency_name">
								<span class="receive wx_fontSize3">{{ val.coin_symbol }}</span>
								<span class="form wx_fontSize2 wx_one_ellipsis">{{ val.coin_name }}</span>
							</span>
							<div class="amount_of wx_rt wx_fontSize2 color-gray" v-if="val.status == 1"
								@click="deletCion(val.coin_symbol)">{{ $t('移除') }}</div>
							<div class="amount_of wx_rt wx_fontSize2" v-else @click="addCion(val.coin_symbol)">{{ $t('添加') }}</div>
						</li>
					</ul>
				</li>
			</ul>
		</div>
		<div class="box" v-show="isShow" @click.self="select()">
			<ul class="share">
				<div class="triangle">
					<div class="triangle_border_up">
						<span></span>
					</div>
				</div>
				<li v-for="(item, index) in list" @click="toggle(index)" :class="{ 'is_active': index == active }" :key="index">
					<span class="searchmain wx_fontSize2">{{ $t(item) }}</span>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { httpCloudCoins, httpCloudAdd, httpCloudDelete, httpCloudSearch } from "@/api/index";
import { Toast } from "mint-ui";
export default {
	data: function () {
		return {
			searchValue: '',
			cancel: this.$t('取消'),
			isShow: false,
			list: ['所有币种', '已添加币种', '未添加币种'],
			active: 0,
			CoinsList: [],
			open: require('../../assets/img/login_ico_xia.png'),
			close: require('../../assets/img/ico_shouqi_tjbz.png'),
			status: 'all',
			searchList: []
		}
	},
	watch: {
		searchValue: function (newvs, oldvs) {
			if (newvs != '') {
				this.$refs.main_list.style.display = 'none';
			} else {
				this.$refs.main_list.style.display = 'block';
			}
		},
	},
	activated() {
		var mintCell = document.querySelector('.mint-search');
		mintCell.style.width = '70%';
		mintCell.style.height = '40px';
		mintCell.style.padding = '2px';
		var searchbar = document.querySelector('.mint-searchbar');
		searchbar.style.padding = '0';
		searchbar.style.background = '#fff';
		this.addList('all');
	},
	methods: {
		search() {
			this.searchCion();
		},
		select() {
			this.isShow = !this.isShow;

		},
		toggle(index) {
			this.active = index;
			if (index == 0) {
				this.status = 'all';
				this.addList('all');
			} else if (index == 1) {
				this.status = 'display';
				this.addList('display');
			} else if (index == 2) {
				this.status = 'none';
				this.addList('none');
			}
			this.select();

		},
		addList(status) {
			httpCloudCoins({ status: status })
				.then(res => {
					this.CoinsList = [];
					this.CoinsList = res.data.list;
					for (var i = 0; i < this.CoinsList.length; i++) {
						console.log(this.CoinsList[i]);
						this.CoinsList[i].img_url = window.getLocalCoinImg(this.CoinsList[i].coin_symbol);
					}
				})
				.catch(() => { });
		},
		addCion(coin_symbol) {
			httpCloudAdd({ coin_symbol: coin_symbol })
				.then(res => {
					if (res.code == 1) {
						Toast(res.msg);
						this.addList(this.status);
					}
				})
				.catch(() => { });
		},
		deletCion(coin_symbol) {
			httpCloudDelete({ coin_symbol: coin_symbol })
				.then(res => {
					if (res.code == 1) {
						Toast(res.msg);
						this.addList(this.status);
					}
				})
				.catch(() => { });
		},
		searchCion() {
			httpCloudSearch({ keyword: this.searchValue })
				.then(res => {
					this.searchList = [];
					this.searchList = res.data.list;
					for (var i = 0; i < this.searchList.length; i++) {
						console.log(this.searchList[i]);
						this.searchList[i].img_url = window.getLocalCoinImg(this.searchList[i].coin_symbol);
					}
				})
				.catch(() => { });
		},
		openLlist(index) {
			var tabCardCollection = document.querySelectorAll('.childList');
			var len = tabCardCollection.length;
			if (tabCardCollection[index].style.display == "" || tabCardCollection[index].style.display == "none") {
				tabCardCollection[index].style.display = "block";
			} else {
				tabCardCollection[index].style.display = "none";
			}
		}

	}
}
</script>
<style>
.mint-searchbar-inner .mintui-search {
	font-size: 18px;
	margin-right: 10px;
}

.mint-searchbar-inner .mint-searchbar-core {
	color: #000
}

.mint-searchbar-cancel {
	font-size: 14px;
}
</style>
<style scoped>
.mint-search {
	margin-left: 10%;
}

#search {
	width: 100%;
	height: 100%;
	overflow: hidden;
}

.mint-header {
	background: #ffffff;
	color: #212529;
}

.mint-button--default {
	color: #656b79 !important;
}

form {
	border-bottom: 1px solid #e3e8ed;
}

.back {
	position: absolute;
	top: 0;
	left: 0;
	width: 10%;
	height: 40px;
	line-height: 40px;
	text-align: center;
}

.search_content {
	padding: 20px 15px 0 15px;
}

.back img {
	width: 10px;
	height: 16px;
}

.select {
	width: 10%;
	height: 40px;
	position: absolute;
	right: 0;
	top: 10px;
	text-align: center;
}

.main_list {
	padding: 0px 15px 0 15px;
	height: calc(100% - 40px);
	overflow-y: scroll;
}

.main_show {
	width: 100%;
}

.childList {
	width: 80%;
	margin-left: 20%;
	display: none;
}

.content_detail li {
	width: 100%;
	background: #fff;
	border-bottom: 1px solid #e3e8ed;
}

.oImg {
	width: 40px;
	height: 40px;
	margin: 10px 14px 9px 0px;
	border: 1px solid #dddddd;
	border-radius: 50%;
	margin-left: 10px;
}

.content_detail li .selectCoin {
	width: 36px;
	height: 100%;
	position: absolute;
	top: 0px;
	left: -2%;
}

.selectCoin img {
	width: 12px;
	height: 7px;
	position: relative;
	top: 30px;
}

.currency_name {
	position: relative;
	display: inline-block;
	top: -30px;
	width: 50%;
}

.receive {
	position: absolute;
	top: 0;
}

.form {
	position: relative;
	top: 25px;
	color: #8c92a8;
	width: 100%;
	height: 20px;
	display: inline-block;
	overflow: hidden;
}

.amount_of {
	width: 20%;
	text-align: right;
	padding: 5px 0;
	border: 1px solid #1296db;
	text-align: center;
	margin-top: 17px;
	color: #1296db;
}

.box {
	position: absolute;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.3);
	z-index: 5;
	width: 100%;
	height: 100%;
}

.share {
	min-width: 120px;
	position: absolute;
	background: #fff;
	top: 54px;
	right: 15px;
	border-radius: 6px;
	box-shadow: 0 0 20px rgba(5, 61, 109, 0.2);
}

.share li {
	margin: 0 15px;
	height: 51px;
	border-bottom: 1px solid #e3e8ed;
	line-height: 51px;
}

.searchmain {
	color: #212529;
	position: relative;
}

.share .is_active .searchmain {
	color: #0191f5;
}

.triangle {
	position: relative;
	top: -8px;
	left: 80%;
}

.triangle_border_up {
	width: 0;
	height: 0;
	border-width: 0 8px 8px;
	border-style: solid;
	border-color: transparent transparent #fff;
	/*透明 透明  灰*/
	position: relative;
}

.color-gray {
	color: #656b79;
	border: 1px solid #656b79;
}
</style>
